{
  "chooseFolder": "Ordner wählen…",
  "chosen_one": "{{name}} · {{count}} Datei",
  "chosen_other": "{{name}} · {{count}} Dateien",
  "prompt": "Datei oder Ordner hierher ziehen oder klicken, um Dateien zu wählen",
  "remove": "Entfernen",
  "severalFiles": "Mehrere Dateien"
}
